/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PublicLegalTermsEntity = {
    id: string;
    organizationId: string | null;
    instructorId: string | null;
    type: PublicLegalTermsEntity.type;
    title: string;
    text: string;
    archived: boolean;
};
export namespace PublicLegalTermsEntity {
    export enum type {
        PRIVACY_POLICY = 'PRIVACY_POLICY',
        TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
        REVOCATION_POLICY = 'REVOCATION_POLICY',
    }
}

